module.exports = __webpack_public_path__ + "img/arrow-down-small-big.634278c5.svg";